import { html, type Html, Page, View } from 'rune-ts';
import klass from './SpecificCommerceLaws.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { SCL20240617View } from './views/20240617_SCLView';
import { BaseLayoutOptions } from '../../../features/Core/service';

export type SpecificCommerceLawsPageData = {
  is_mobile: boolean;
  layout_options: BaseLayoutOptions;
};

export class SpecificCommerceLawsBody extends View<SpecificCommerceLawsPageData> {
  protected override template(data: SpecificCommerceLawsPageData): Html {
    return html`${new SCL20240617View({ is_mobile: data.is_mobile })}`;
  }
}

export class SpecificCommerceLawsPage extends Page<SpecificCommerceLawsPageData> {
  protected override template(data): Html {
    const { layout_options } = data;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: new SpecificCommerceLawsBody(data),
            footer_data: { ...footer_links, is_mobile: layout_options.is_mobile, lang: ET.lang },
          },
          {
            has_bottom_tab_bar: true,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
